import Button from '@sendsprint/ui-react/dist/components/Button';
import DisplayAmount from '@src/components/displayAmount';
import React from 'react';
import PaymentDropdown from '../paymentDropdown';
import { PayBtnClickHandlerOptions, PaymentMethodI } from '../..';
import useTransactionPin from '../../hooks/useTransactionPin';
import VeriffModal from '@src/components/veriffModal';
import { FirstTimeUserFormI } from '../authenticationCode/firstTimeUser';
import { RegularUserFormI } from '../authenticationCode/regularUser';
import AuthenticationCode from '../authenticationCode';

interface Props {
  value: number;
  currency: string;
  handlePayment?: (
    // eslint-disable-next-line no-unused-vars
    variant: PaymentMethodI,
    // eslint-disable-next-line no-unused-vars
    options: PayBtnClickHandlerOptions
  ) => void | Promise<boolean>;
  isSubmitting: boolean;
  txRef: string | undefined;
  isNethoneCheck: boolean;
  paymentCodeValue?: number;
}

const PaymentCodeDropdown = ({
  currency,
  value,
  handlePayment,
  isNethoneCheck,
  isSubmitting,
  txRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  paymentCodeValue
}: Props) => {
  const handleFirstTimeCallback = (values: FirstTimeUserFormI) => {
    if (handlePayment) {
      return handlePayment('payment-code', { Pin: values.code });
    }
  };

  const handleRegularCallback = (values: RegularUserFormI) => {
    if (handlePayment) {
      return handlePayment('payment-code', { Pin: values.code });
    }
  };

  const {
    isPinAvailable,
    checkPinLoading,
    createPinLoading,
    handleCheckPin,
    handleModalClose,
    handleFirstTimeSubmit,
    handleRegularSubmit,
    isOpen: isModalOpen,
    handleVeriffClose,
    isVeriffOpen
  } = useTransactionPin({ handleFirstTimeCallback, handleRegularCallback, isNethoneCheck, txRef });

  // const isTransactionLoading = createPinLoading || isSubmitting || (!!txRef && !isNethoneCheck);
  const isTransactionWithoutNethoneLoading = createPinLoading || isSubmitting;

  return (
    <>
      <PaymentDropdown
        isOpen={true}
        handleToggle={() => undefined}
        header={'Pay with payment code'}
        // headerImage={paymentWithFlutterwave}
      >
        <Button
          type="button"
          label={
            <DisplayAmount prefix="Pay" value={value} currency={currency} />
            // <DisplayAmount prefix="Pay" value={paymentCodeValue || value} currency={currency} />
          }
          isBlock={true}
          onClick={handleCheckPin}
          showSpinner={checkPinLoading}
          disabled={checkPinLoading}
        />
      </PaymentDropdown>
      <AuthenticationCode
        variant={isPinAvailable ? 'regular' : 'first-time'}
        handleFalse={handleModalClose}
        state={isModalOpen}
        handleRegularSubmit={handleRegularSubmit}
        handleFirstTimeSubmit={handleFirstTimeSubmit}
        isLoading={isTransactionWithoutNethoneLoading}
      />
      <VeriffModal state={isVeriffOpen} handleClick={handleVeriffClose} />
    </>
  );
};

export default PaymentCodeDropdown;
